/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { headApi } from "utils/headApi";
// import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// import Slide from "@material-ui/core/Slide";
// import Tooltip from "@material-ui/core/Tooltip";
// import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Table from "components/Table/Tables.js";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import BanglesHeader from "views/BanglesPage/Section/BanglesHeader";
import BanglesHeaderLink from "views/BanglesPage/Section/BanglesHeaderLink";
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyl = makeStyles(aboutUsStyle);

export default function MyOrder({ ...rest }) {
    const [addCart, setAddCart] = React.useState([]);
    // const [userId, setUserId] = React.useState("");
    const [load, setLoad] = React.useState(false);

    const classes = useStyles();
    const history = useHistory();

    const classesTable = useStylesTable();
    const classeCart = useStyleCart();
    const classeTitel = useStyl();

    const activeSession = sessionStorage.getItem("sessionData");
    const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

    const date = Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    }).format(new Date()).replaceAll('/', '-');

    const current = new Date();
    const dateCurrent = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
    current.setDate(current.getDate() + 10);
    let dateEx = new Date(current).toLocaleDateString("de");

    async function getList() {
        const getList = await fetch(headApi + `/order/byClient?clientid=${userObj && userObj.id}&userid=1`);
        const res = await getList.json();
        // setAddCart(res && res.OrderData ? res.OrderData : history.push("/"));
        if (res.error === "true") {
            setLoad(false)
            history.push("/error-page");
        } else {
            setLoad(true)
            // setAddCart(res.OrderData)
            setAddCart(res && res.OrderData ? res.OrderData : history.push("/error-page"));
        }
    }

    useEffect(() => {
        getList();
    }, []);


    return (
        <div>
            <Helmet>
                <title>My Order</title>
            </Helmet>
            {load ? <>
                <BanglesHeader
                    color="info"
                    brand="Home"
                    links={<BanglesHeaderLink dropdownHoverColor="info" />}
                    fixed
                    // changeColorOnScroll={{
                    //     height: 200,
                    //     color: "info",
                    // }}
                    {...rest}
                />
                <Parallax
                    image={require("assets/img/bg6.jpg").default}
                    filter="dark"
                    className={classes.parallax}
                >
                    <div className={classeTitel.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={8}
                                sm={8}
                                className={classNames(
                                    classeTitel.mlAuto,
                                    classeTitel.mrAuto,
                                    classeTitel.textCenter
                                )}
                            >
                                <h1 className={classeTitel.title}>ORDER</h1>
                                <h4>

                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classeCart.main, classeCart.mainRaised)}>
                    <div className={classeCart.container}>
                        <Card plain>
                            <CardBody plain>
                                <h3 className={classeCart.cardTitle}>My Order</h3>
                                <Table
                                    // tableHead={[
                                    //     <span className={classesTable.tableHead}>Sr.<br />No.</span>,
                                    //     "",
                                    //     <span className={classesTable.tableHead}>Description of Goods</span>,
                                    //     <span className={classesTable.tableHead + " " + classesTable.headRight}>Quantity</span>,
                                    //     <span className={classesTable.tableHead + " " + classesTable.headRight}>Price</span>,
                                    //     <span className={classesTable.tableHead + " " + classesTable.headRight}>Amount</span>,
                                    //     ""
                                    // ]}

                                    tableData={addCart.map((c, index) => [
                                        [
                                            <span className={classesTable.OrderlistDescription}>{index + 1}</span>,
                                            <div>
                                                <span className={classesTable.OrderlistDescription}>Order ID: </span><br />
                                                <span className={classesTable.OrderlistDescription}>Date:</span><br />
                                                <span className={classesTable.OrderlistDescription}>Boxs/Dozen:</span><br />
                                                <span className={classesTable.OrderlistDescription}>Cartoon:</span><br />
                                                <span className={classesTable.OrderlistDescription}>Bill Amount:</span><br />
                                                <span className={classesTable.OrderlistDescription}>Payment Status:</span><br />
                                                <span className={classesTable.OrderlistDescription}>Status:</span><br />
                                            </div>,
                                            <div>
                                                <span className={classesTable.OrderlistDescription}>{c.id}</span><br />
                                                <span className={classesTable.OrderlistDescription}>{c.date.slice(0, -12)}</span><br />
                                                <span className={classesTable.OrderlistDescription}>{c.totalbox + " - " + "Units"}</span><br />
                                                <span className={classesTable.OrderlistDescription}>{c.totalcarton}</span><br />
                                                <span className={classesTable.OrderlistDescription}>₹ {Math.round(c.amount) + "/-"}</span><br />
                                                <span className={classesTable.OrderlistDescription}>{c.paymentstatus + "%"}</span><br />
                                                <span className={classesTable.OrderlistDescription}>{c.status}</span><br />
                                            </div>,
                                            <span className={classesTable.headRight + " " + classesTable.listNumber}>
                                                <Button color="info" round href={`/order-view?id=${c.id}`}>Order Details</Button> &nbsp;&nbsp;&nbsp;
                                                <Button color="info" round href={`/payment-recieved?id=${c.id}`}>Payment Details</Button>
                                            </span>,
                                            <span>

                                            </span>,
                                            <span></span>
                                        ],
                                    ])}
                                />
                                <hr />

                            </CardBody>
                        </Card>
                    </div>
                </div>
                <BanglesFooter />
            </> : ""}
        </div>
    );
}